import { component } from 'vue-tsx-support'

const loadingMessages: readonly string[] = [
	'Almost done',
	'Clipping coupons',
	'Fixing bugs',
	'Fixing typos',
	'Hiring staff',
	'Looking for deals',
	'Making a list',
	'Ordering products',
	'Organizing products',
	'Still loading',
	'Stocking shelves',
	'Taking inventory',
	'Training cashiers',
	'Unloading the truck',
	'Wandering aisles',
]

export default component({
	name: 'LoadingScreen',
	data() {
		return {
			loadingMessage: 'Loading',
			timer: 0,
		}
	},
	destroyed(): void {
		window.clearInterval(this.timer)
		this.timer = 0
	},
	mounted(): void {
		this.timer = window.setInterval(() => this.setRandomMessage(), 3000)
	},
	methods: {
		setRandomMessage(): void {
			const randomIndex = Math.floor(Math.random() * loadingMessages.length)
			this.loadingMessage = loadingMessages[randomIndex]
		},
	},
	render() {
		return (
			<div class="ui active dimmer">
				<div class="ui text loader">{this.loadingMessage}...</div>
			</div>
		)
	},
})
